import type { IconData } from '@stacksjs/iconify-core'

export const divisionCircleRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 24C4.5 13.23 13.23 4.5 24 4.5S43.5 13.23 43.5 24S34.77 43.5 24 43.5S4.5 34.77 4.5 24M24 .5C11.021.5.5 11.021.5 24S11.021 47.5 24 47.5S47.5 36.979 47.5 24S36.979.5 24 .5m-4 13a4 4 0 1 1 8 0a4 4 0 0 1-8 0m-7.437 7.181c1.882-.084 5.369-.181 11.437-.181s9.555.097 11.437.181c1.352.06 2.835.746 3.013 2.356q.049.427.05.963c.001.536-.018.678-.05.963c-.178 1.61-1.661 2.296-3.013 2.356c-1.882.084-5.369.181-11.437.181s-9.555-.097-11.437-.181c-1.352-.06-2.835-.746-3.013-2.356q-.049-.427-.05-.963c-.001-.536.018-.678.05-.963c.178-1.61 1.661-2.295 3.013-2.356M20 34.5a4 4 0 1 1 8 0a4 4 0 0 1-8 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default divisionCircleRemix
